import axios from "axios";
import { Constants } from "../utils/constants";
import { CookieService } from './cookie.service';
import { Utils } from "../utils/utils";
import { campaignFilterOptions } from './api-helpers';

const getAuthAnsid = () => CookieService.getCookie('ANsid');

export const getCampaignData = (filterObj, hasNext, campaignType) => {
  let filterParams = {};
  if (filterObj) {
    filterParams = campaignFilterOptions(filterObj);
  }
  let queryParam = { ...campaignType };
  let url = `${Constants.CampaignDataUrl}`;
  if (!hasNext) {
    queryParam["client-id"] = Utils.getRouteParam("clientid");
    if (!campaignType["is-recent"]) {
      queryParam["page-no"] = 1;
    }
  } else {
    url = hasNext;
  }
  if (!campaignType["is-recent"]) {
    for (let filter in filterParams) {
      queryParam[filter] = filterParams[filter];
    }
  }
  return axios.get(url, {
    params: { ...queryParam, "pmds-version": "v3" },
    headers: { ansid: CookieService.getCookie('ANsid'), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response,
    (error) => Promise.reject(error));
};

export const getCampaignDataAggrid = (filterObj, hasNext, isArchive = false) => {
  let filterParams = {};
  if (filterObj) {
    filterParams = campaignFilterOptions(filterObj);
  }
  let queryParam = {};
  if (!hasNext) {
    queryParam = { "client-id": Utils.getRouteParam("clientid"), "page-no": 1 };
  }
  for (let filter in filterParams) {
    queryParam[filter] = filterParams[filter];
  }
  queryParam['is-archive'] = isArchive ? isArchive : false;
  let url = hasNext ? hasNext : `${Constants.CampaignDataUrl}`;
  return axios.get(url, {
    params: { ...queryParam },
    headers: { ansid: CookieService.getCookie('ANsid'), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response,
    (error) => Promise.reject(error));
};

export const sortCampaigns = (sortColumn, sortOrder, pageNo, isArchive, versionOneApi = 'V1') => {
  let mapObj = {
    'endDate': 'End Date', 'startDate': 'Start Date', 'campaignName': 'Campaign Name',
    'budget': 'Budget', 'exportStatus': 'Export Status', 'source': 'Data Source'
  };
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.get(url, {
    params: {
      "client-id": Utils.getRouteParam("clientid"), "page-no": pageNo || 1,
      "sort-column": mapObj[sortColumn], "sort-order": sortOrder,
      "is-archive": isArchive ? isArchive : false
    },
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response,
    (error) => Promise.reject(error));
};

export const searchCampaign = (queryParam, campaignTabType) => {
  let url = `${Constants.CampaignDataUrl}`;
  queryParam['source'] = "planned";
  queryParam['client-id'] = Utils.getRouteParam("clientid");
  queryParam = { ...queryParam, ...campaignTabType };
  return axios.get(url, {
    params: { ...queryParam, "pmds-version": "v3" },
    headers: { ansid: CookieService.getCookie('ANsid'), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response,
    (error) => Promise.reject(error));
};

export const updateCampaign = (payload, campaignId, versionOneApi = 'V1') => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.put(url + '/' + campaignId, payload, {
    headers: { ansid: CookieService.getCookie('ANsid'), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response,
    (error) => Promise.reject(error));
};

export const sendCampaignToMediaOcean = (payload, campaignId, versionOneApi = 'V1') => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.post(url + '/' + campaignId + '/send-to-mo?client-id=' + Utils.getRouteParam("clientid"),
    payload,
    { headers: { ansid: getAuthAnsid(), clientid: Utils.getRouteParam("clientid") } })
    .then((response) => response && response['data']);
};

export const getCampaignDataById = (campaignId, clientId, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.get(url + '/' + campaignId, {
    params: { "client-id": Utils.getRouteParam("clientid"), "pmds-version": "v3" },
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response && response.data,
    (error) => Promise.reject(error));
};

export const mergeCampaigns = (campaignId, payload) => {
  return axios.post(Constants.CampaignDataUrlV1 + '/' + campaignId + '/map', payload, {
    headers: { ansid: getAuthAnsid(), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response && response['data']);
};

export const unmergeCampaigns = (campaignId, payload, versionOneApi = "V1") => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.post(url + '/' + campaignId + '/unmap', payload, {
    headers: { ansid: getAuthAnsid(), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response && response['data']);
};

export const prepareCampaignData = (responseData) => {
  let data = [];
  for (let index = 0; index < responseData?.length; index++) {
    const mediaObj = responseData[index];
    const dataObj = { ...mediaObj };
    dataObj['id'] = mediaObj['id'] || '';
    dataObj['startDate'] = mediaObj['start_date'] || '';
    dataObj['endDate'] = mediaObj['end_date'] || '';
    dataObj['campaignName'] = mediaObj['campaign_name'] || '';
    dataObj['campaignDisplayName'] = mediaObj['campaign_display_name'] || '';
    dataObj['partners'] = mediaObj['partners'] || '';
    dataObj['budget'] = mediaObj.media_attributes?.media_budget?.campaign_budget || '';
    dataObj['exportStatus'] = mediaObj['export_status'] || '';
    dataObj['exportStatusError'] = mediaObj['error_description'] || '';
    dataObj['source'] = mediaObj['data_source'] || '';
    dataObj['createdOn'] = mediaObj['created_at'] || '';
    dataObj['createdBy'] = mediaObj['createdBy'] || '';
    dataObj['clientName'] = mediaObj['client_name'] || '';
    dataObj['importStatus'] = mediaObj['import_status'] || '';
    dataObj['mediaBudget'] = mediaObj.media_attributes?.media_budget || '';
    dataObj['channels'] = mediaObj.media_attributes?.channels || '';
    dataObj['fiscal year'] = mediaObj['fiscal_year'] || '';
    dataObj['campaign period'] = mediaObj['campaign_period'] || '';
    dataObj['line of business/business/brand'] = mediaObj['line_of_business'] || '';
    dataObj['product/product line'] = mediaObj['product_line'] || '';
    dataObj['campaign objective'] = mediaObj['campaign_objective'] || 'Awareness';
    dataObj['country'] = mediaObj['country'] || '';
    dataObj['currency'] = mediaObj['currency'] || '';
    dataObj['market/region'] = mediaObj['region'] || '';
    dataObj['funnel stage'] = mediaObj['funnel stage'] || '';
    dataObj['campaign name/description'] = mediaObj['campaign_name'] || '';
    dataObj['campaignTaxonomy'] = mediaObj['campaign_taxonomy'];
    dataObj['taxonomy_schema'] = mediaObj['taxonomy_schema'];
    dataObj['campaign_taxonomy_display'] = mediaObj['campaign_taxonomy_display'];
    dataObj['_uniqueKey'] = mediaObj["id"] + "-" + index;
    dataObj['synthetic_id'] = mediaObj["synthetic_id"];
    dataObj['parent_id'] = mediaObj["parent_id"];
    dataObj['mediaocean_id'] = mediaObj["mediaocean_id"];
    dataObj['client_code'] = mediaObj["client_code"];
    dataObj['created_at'] = mediaObj["created_at"];
    dataObj['created_by'] = mediaObj["created_by"];
    dataObj['clientid'] = mediaObj["clientid"] || '';
    dataObj['estimateid'] = mediaObj["estimateid"] || '';
    dataObj['productid'] = mediaObj["productid"] || '';
    dataObj['parentSyntheticId'] = mediaObj["parentSyntheticId"] || undefined;
    dataObj['parentStatus'] = mediaObj["parentStatus"] || undefined;
    data.push(dataObj);
  }
  return data;
};

export const prepareCampaignDataForClientCode = (mediaObj, taxonomyName, taxonomyDisplay, taxonomySchemay) => {
  const dataObj = {};
  dataObj['campaignTaxonomy'] = mediaObj['campaign_taxonomy'] || taxonomyName;
  dataObj['taxonomySchema'] = mediaObj['taxonomy_schema'] ? (mediaObj['taxonomy_schema'].trim() || taxonomySchemay) : taxonomySchemay;
  dataObj['campaignTaxonomyDisplay'] = mediaObj['campaign_taxonomy_display'] ? (mediaObj['campaign_taxonomy_display'].trim() || taxonomyDisplay) : taxonomyDisplay;
  return dataObj;
};

export const fetchCount = (campaigns, searchEnabled = false) => {
  if (searchEnabled) {
    const childCampaignsCount = campaigns.reduce((totalChildCount, campaign) => {
      return totalChildCount + (campaign?.children?.length || 0);
    }, 0);
    return { fetchCount: campaigns.length + childCampaignsCount };
  } else {
    let childCampaignsCount = 0;
    campaigns.map(item => {
      if (item.nestedData && Array.isArray(item.nestedData)) {
        for (const nestedItem of item?.nestedData) {
          childCampaignsCount++;
        }
      }
      return item;
    });
    return { fetchCount: campaigns.length + childCampaignsCount };
  }
};

export const createCampaignNestedData = (campaigns, isTableNested, setIsTableNested) => {
  const nestedData = {};
  for (const item of campaigns) {
    if (item.parent_id) {
      const parentId = item.parent_id;
      if (!(parentId in nestedData)) {
        nestedData[parentId] = [];
      }
      nestedData[parentId].push(item);
    }
  }
  let transformedFilterData = [];
  let nestedCampaigns = [];
  for (const item of campaigns) {
    if (!(item.parent_id in nestedData) || !(item.synthetic_id in nestedData)) {
      let childCampaign = nestedData[item.id] || nestedData[item.synthetic_id];
      if (childCampaign?.length) {
        if (!(item?.nestedData?.length)) {
          item.nestedData = [];
        }
        childCampaign.forEach(val => {
          val.local_currency_name = item.local_currency_name;
          val['isCheckBox'] = false;
          val['marginClass'] = "margin-left-20";
          val['nested'] = true;
          val.partners = val?.channels?.reduce((acc, channel) => {
            const publishersName = [];
            channel?.publishers?.map((publisher) => {
              if (!acc.includes(publisher?.publisher_name)) {
                publishersName.push(publisher?.publisher_name);
              }
            });
            return acc.concat(publishersName);
          }, []);
        });
        item.nestedData.push(...childCampaign);
        nestedCampaigns = nestedCampaigns.concat(childCampaign);
        if (!isTableNested) {
          setIsTableNested(true);
        }
        if (!item?.nested) {
          item['nested'] = true;
          item?.nestedData.forEach((nestedItem) => {
            nestedItem['nested'] = true;
          });
        }
      }
      transformedFilterData.push(item);
    }
  }
  let duplicatedCampaign = new Set(nestedCampaigns.map(({ synthetic_id }) => synthetic_id));
  transformedFilterData = transformedFilterData.filter(({ synthetic_id }) => !duplicatedCampaign.has(synthetic_id));
  const fc = fetchCount(transformedFilterData, false);
  return { transformedFilterData, fetchCount: fc };
};

export const sortCampaignsAggrid = (sortColumn, sortOrder, isArchive, versionOneApi = 'V1', hasNext) => {
  let mapObj = {
    'source': 'Data Source', 'campaignName': 'Campaign Name',
    'endDate': 'End Date', 'startDate': 'Start Date', 'mediaocean_status': 'Export Status',
  };
  const paramsObj = {
    "client-id": CookieService.getCookie("clientId"),
    "sort-column": mapObj[sortColumn], "sort-order": sortOrder,
    "is-archive": isArchive ? isArchive : false
  };
  let url;
  if (hasNext) {
    url = hasNext;
  } else {
    url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
    paramsObj['page-no'] = 1;
  }
  return axios.get(url, {
    params: paramsObj,
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: CookieService.getCookie("clientId") }
  }).then((response) => response,
    (error) => Promise.reject(error));
};

export const searchCampaignsAggrid = (searchParam, isArchive, versionOneApi = 'V1', hasNext) => {
  let paramsObj = {
    "client-id": CookieService.getCookie("clientId"),
    "search": searchParam,
    "is-archive": isArchive ? isArchive : false,
  };
  let url;
  if (hasNext) {
    url = hasNext;
  } else {
    url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
    paramsObj['page-no'] = 1;
  }
  return axios.get(url, {
    params: { ...paramsObj },
    headers: { ansid: CookieService.getCookie('ANsid'), clientid: CookieService.getCookie("clientId") }
  }).then((response) => response,
    (error) => Promise.reject(error));
};

export const transformDataAggrid = (data) => {
  const map = new Map();
  const mapWithSynthetic = new Map();
  const result = [];
  data.forEach((item, index) => {
    if (item?.amd_campaign_id) {
      map.set(item?.amd_campaign_id, { ...item, originalIndex: index });
    }
    if (item?.synthetic_id) {
      mapWithSynthetic.set(item?.synthetic_id, { ...item });
    }
  });
  data.forEach((item) => {
    if (item?.parent_id != null) {
      let parent = null;
      if (item.data_source?.toLowerCase() === 'mediaocean') {
        let parentWithId = mapWithSynthetic.get(item?.parent_id);
        parent = map.get(parentWithId?.amd_campaign_id);
      } else {
        parent = map.get(item?.parent_id);
      }
      if (parent) {
        parent.nestedData = parent.nested ? parent.nestedData : [];
        item.local_currency_name = parent.local_currency_name;
        item.parent_amd_campaign_id = parent?.amd_campaign_id;
        item.parentSyntheticId = parent?.synthetic_id;
        item.parentStatus = parent?.export_status;
        parent.nestedData.push(item);
        parent['nested'] = true;
      }
    }
  });
  map.forEach((item) => {
    if (!item?.parent_id) {
      if (item.child_count && !item.nested) {
        item.nestedData = [{ campaignName: '', id: item.id + "child" }];
      }
      result.push(item);
    }
  });
  result.sort((a, b) => a.originalIndex - b.originalIndex);
  return result;
};

export const setCampaignsData = (campaigns, isTableNested, setIsTableNested, childCampaigns, parentId, searchEnabled = false) => {
  if (childCampaigns.length) {
    let index = campaigns.findIndex(item => item.id === parentId || item.synthetic_id === parentId);
    if (index !== -1) {
      childCampaigns.forEach((nestedItem) => {
        nestedItem['isCheckBox'] = false;
        nestedItem['marginClass'] = "margin-left-20";
        nestedItem['nested'] = true;
        nestedItem.local_currency_name = campaigns[index].local_currency_name;
        nestedItem.parent_amd_campaign_id = campaigns[index]?.amd_campaign_id;
        nestedItem.parentSyntheticId = campaigns[index]?.synthetic_id;
        nestedItem.parentStatus = campaigns[index]?.export_status;
        nestedItem.partners = nestedItem?.channels?.reduce((acc, channel) => {
          const publishersName = [];
          channel?.publishers?.map((publisher) => {
            if (!acc.includes(publisher?.publisher_name)) {
              publishersName.push(publisher?.publisher_name);
            }
          });
          return acc.concat(publishersName);
        }, []);
      });
      campaigns[index].nestedData = childCampaigns;
      campaigns[index].nested = true;
      campaigns[index].isCheckBox = true;
      if (!isTableNested) {
        setIsTableNested(true);
      }
    }
  }
  const fc = fetchCount(campaigns, searchEnabled);
  return { transformedFilterData: campaigns, fetchCount: fc };
};
